export default {
  'adjustment.title': '金额调整管理',
  'adjustment.discount': '折扣',
  'adjustment.fee': '附加费',

  'adjustment.action.createFee': '新建费用',
  'adjustment.action.createDiscount': '新建折扣',
  'adjustment.action.createPaymentMethod': '新建支付方式',
  'adjustment.action.createQuickNotes': '新建快捷备注',
};
